module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/invitro.722bfea1.svg";